// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"0b8a091b","498":"d36e06a2","703":"a5fa7c57","787":"ac343c3f"}[chunkId] + ".chunk.js";
};